import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// Drop-in for ng6-toastr-notifications' ToastrManager (that package has no Ivy build).
// Its per-call options used different keys (toastTimeout, ...), so the `{ timeOut }` objects
// callers pass were always ignored there - they stay ignored here to keep the same behavior.
@Injectable({ providedIn: 'root' })
export class ToastrManager {
  constructor(private toastr: ToastrService) { }

  successToastr(message: any, title?: string, options?: any) {
    return this.toastr.success(message, title);
  }

  errorToastr(message: any, title?: string, options?: any) {
    return this.toastr.error(message, title);
  }
}
